import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import styled from "styled-components";
import classnames from "classnames";
import { rem } from "polished";
import { Localize } from "../../../../locale/localization";

const NavWrapper = styled.nav`
  flex: 1;
  margin-right:auto;
  margin-block-end:0;
  ul {
    display: flex;
    justify-content: flex-start;
    line-height: ${rem("14px")};
    gap:2rem;
    li:last-child {
      margin-right:0;
      padding-right:0;
  }

  }

  li {
    padding: 0 ${rem("5px")};
    margin-bottom:auto;
    margin-top:auto;
  }

  li a {
    color: #f0cec4;
    font-family: FyranSans-Core;
    font-size: 1rem;

    color: white;

    &.active {
      font-family: FyranSans-SemiBold;
      font-weight:600;
      color: #FF3334;
    }
  }

  &.min {
    ul {
      justify-content: unset;

      li {
        margin-right: 3.375rem;
      }
    }
  }
`;
const NoSpace = styled.li`
white-space:nowrap;
`
const NavigationDesktop = props => {
  const { currentUser } = props;
  const className = classnames({
    min: !currentUser.hasAccessToPrizeProgram
  });

  return (
    <NavWrapper className={className}>
      <ul>
        <li>
          <NavLink to="/" exact>
            {Localize("navi.root")}
          </NavLink>
        </li>
        <li style={{marginRight:"1.5rem"}}>
          <NavLink to="/product-categories">{Localize("navi.products")}</NavLink>
        </li>
        {currentUser.hasAccessToPrizeProgram && (
          <NoSpace>
            <NavLink to="/prizes">{Localize("navi.prizes")}</NavLink>
          </NoSpace>
        )}
        {currentUser.hasAccessToAdmin && (
          <li>
            <NavLink to="/admin">{Localize("navi.admin")}</NavLink>
          </li>
        )}
        <li>
          <a href="/files/CMore-urheilukalenteri.pdf" target="_blank">{Localize("navi.sportsCalendar")}</a>
        </li>
      </ul>
    </NavWrapper>
  );
};

export default withRouter(NavigationDesktop);



// WEBPACK FOOTER //
// ./src/modules/common/components/app/DesktopNavigation.js